import { createSelector } from 'reselect';

export const getQueryParams = state => state.queryParams;

export const getQueryParam = queryParam =>
  createSelector(
    getQueryParams,
    queryParams => queryParams[queryParam.toLowerCase()]
  );

// TODO (Miguel): refactor input
export const getUnObfuscatedObject = state => {
  const obfuscatedArray = getQueryParam('webkey')(state).split(':');
  const unObfuscatedObject = {
    username: '',
    password: '',
    reservationId: '',
    personId: '',
    confKey: '',
    userEmail: ''
  };
  const propertyNames = Object.getOwnPropertyNames(unObfuscatedObject);
  let i = 1;
  for (i; i < obfuscatedArray.length; i++) {
    if (i !== 2) {
      unObfuscatedObject[propertyNames[i - 1]] = unObfuscate(
        obfuscatedArray[i]
      );
    } else {
      unObfuscatedObject[propertyNames[i - 1]] = obfuscatedArray[i];
    }
  }
  return unObfuscatedObject;
};

export const getAllWebkey = state => getQueryParam('webkey')(state);

export const getWebkey = state => getAllWebkey(state).split(':')[0];

export const getVariant = state => getQueryParam('variant')(state);

const unObfuscate = value => {
  return !value
    ? ''
    : value
        .split('')
        .filter((ch, idx) => idx & 1)
        .reverse()
        .join('');
};



// WEBPACK FOOTER //
// ./src/store/reducers/queryParams/selectors.js